import React from 'react';
import { Section } from './ui/Section';
import { CheckCircle2, Gift, ThumbsUp, ThumbsDown } from 'lucide-react';
export function Deliverables() {
  return <Section bg="bg-white" data-id="element-9">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-brand-brown" data-id="element-10">
        Lo que recibes hoy:
      </h2>

      <div className="space-y-4 mb-16" data-id="element-11">
        {[{
        title: 'El Plan de Rescate de 10 Años',
        desc: 'Una hoja de ruta financiera realista desde los 50 hasta los 65.'
      }, {
        title: 'Inventario de Micro-Servicios',
        desc: 'Lista de los 10 trabajos que más pagan hoy en USA a personas de confianza.'
      }, {
        title: 'Manual de "Oficina Móvil"',
        desc: 'Cómo configurar tu WhatsApp Business para que los clientes te tomen en serio.'
      }, {
        title: 'Guía Anti-Estafas Digitales',
        desc: 'Cómo identificar un "scam" en 5 segundos y proteger tus ingresos.'
      }, {
        title: 'Protocolo de Cobro',
        desc: 'Paso a paso para usar Zelle y CashApp con clientes americanos y latinos.'
      }].map((item, i) => <div key={i} className="flex items-start gap-4 p-4 rounded-xl hover:bg-brand-sand transition-colors" data-id="element-12">
            <CheckCircle2 className="w-7 h-7 text-brand-green flex-shrink-0 mt-1" data-id="element-13" />
            <div data-id="element-14">
              <h4 className="text-xl font-bold text-brand-brown" data-id="element-15">
                {item.title}
              </h4>
              <p className="text-lg text-brand-brown-light mt-1" data-id="element-16">{item.desc}</p>
            </div>
          </div>)}

        <div className="mt-8 bg-brand-sand border-2 border-brand-terracotta/30 p-6 md:p-8 rounded-2xl flex items-start gap-5" data-id="element-17">
          <Gift className="w-10 h-10 text-brand-terracotta flex-shrink-0 mt-1" data-id="element-18" />
          <div data-id="element-19">
            <h4 className="text-sm font-bold text-brand-terracotta uppercase tracking-wider mb-1" data-id="element-20">
              Bono Incluido
            </h4>
            <h4 className="text-2xl font-bold text-brand-brown mb-2" data-id="element-21">
              Diccionario de Spanglish Tecnológico
            </h4>
            <p className="text-lg text-brand-brown-light" data-id="element-22">
              Para que nadie te confunda con términos modernos.
            </p>
          </div>
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-8" data-id="element-23">
        <div className="bg-brand-cream p-6 md:p-8 rounded-2xl border border-brand-sand" data-id="element-24">
          <h3 className="text-xl font-bold mb-6 flex items-center gap-3 text-brand-green" data-id="element-25">
            <ThumbsUp className="w-6 h-6" data-id="element-26" /> Para quién es esto:
          </h3>
          <ul className="space-y-4" data-id="element-27">
            {['Latinos en Estados Unidos que llegaron al país después de los 30 o 40 años.', 'Personas que no tienen suficientes créditos de Social Security o ahorros en un 401k.', 'Trabajadores honestos que quieren dejar de hacer esfuerzos físicos extremos y usar más su gestión.', 'Hispanos que quieren dominar las herramientas básicas del celular para no depender de sus hijos o nietos cada vez que necesitan hacer un trámite.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-brand-brown-light text-lg" data-id="element-28">
                <span className="text-brand-green font-bold mt-0.5 text-xl" data-id="element-29">
                  •
                </span>
                <span data-id="element-30">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="bg-white border border-brand-sand p-6 md:p-8 rounded-2xl" data-id="element-31">
          <h3 className="text-xl font-bold mb-6 flex items-center gap-3 text-brand-terracotta" data-id="element-32">
            <ThumbsDown className="w-6 h-6" data-id="element-33" /> Para quién NO es:
          </h3>
          <ul className="space-y-4" data-id="element-34">
            {['Personas que buscan "dinero fácil" sin ofrecer un servicio real.', 'Gente que no está dispuesta a aprender a usar nuevas aplicaciones en su teléfono.', 'Expertos en marketing o personas que ya tienen su retiro asegurado.'].map((item, i) => <li key={i} className="flex items-start gap-3 text-brand-brown-light text-lg" data-id="element-35">
                <span className="text-brand-terracotta font-bold mt-0.5 text-xl" data-id="element-36">
                  •
                </span>
                <span data-id="element-37">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}